import React, { Fragment } from 'react';
import { Table } from 'react-bootstrap';
import styled from 'styled-components';

import useLog from '../hooks/useLog';
import SkeletonText from './SkeletonText';
import { appConfig } from '../config.js';


// function List(props) {
// 	/*
// 		props: - list
// 	*/
// 	var list_jsx = null
// 	if(props.list) list_jsx =
// 			<Fragment>
// 				{props.list.map((item, index) => (
// 			        <li key={index}>
// 			        	<FormattedNumber value={item} separator=" " decimals="" />
// 			        </li>
// 				))}
// 			</Fragment>
// 	return (
// 		<ul style={{listStyleType:"none",padding:0,margin:0}}>
// 			{list_jsx}
// 	    </ul>
// 	)
// }


const theme = appConfig.theme

/*
	tbody tr:hover td {
		background-color: yellow !important;
	}
*/

const CustomTable = styled(Table)`
	background-color: ${theme.backgroundColorLighter1};
	color: white !important;

	/* header custom style */

	th {
		background-color: ${theme.backgroundColorLighter1};
		color: #fff; /* text color */
	}

	/* separator custom style*/

	tbody {
		border-top: 2px solid ${theme.backgroundColorLighter3} !important;
	}

	/* cells custom style */

	tbody tr td {
		--bs-table-accent-bg: initial !important;
		color: white !important; /* text color */
	}

	tbody tr:nth-of-type(odd) td {
		background-color: ${theme.backgroundColorLighter2};
	}

	tbody tr:nth-of-type(even) td {
		background-color: ${theme.backgroundColorLighter1};
	}

	/* hover custom style*/

	tbody tr:hover td {
		background-color: ${theme.backgroundColorLighter3};
	}
`;


/**
 * 
 * @param {*} props.titles - 1d array
 * @param {*} props.values - 2d array, line by line
 * @param {boolean} props.loading - (optional) boolean, displays loader
 * @param {string} props.empty_mess - (optional) string, display if(!values || values.length===0)
 * 
 * 	ex:
		<Tableau
			titles={["Valeur", "Date", "Info"]}
			values={[["Mark", "Otto", "@mdo"],
					["Jack","Tefj","@ok"],
					["Larry","the bird","@lol"]]
			}/>
 * @returns 
 */
export function Tableau(props) {

	// <td key={index}><Spaces count="10"/>&nbsp;</td> // to add right space in table

	const log = useLog("Tableau: ")

	var titles_jsx = null
	if (props.titles)
		titles_jsx =
			<Fragment>
				{props.titles.map((item, index) => (
					<th key={index} scope="col">{item}</th>
				))}
			</Fragment>;

	var values_jsx = null
	var values = props.values

	// to display the white line below titles we need at least an empty line of values
	if (!values || values.length === 0) {
		values = props.titles.map(k => "")
	}

	if (values && !props.loading) {
		if (props.titles.length === 1) { // if 1d we turn into fake 2d
			values = values.map(a => [a])
		}
		values_jsx =
			<Fragment>
				{values.map((item, index) => (
					<tr key={index}>
						{item ? item.map((item2, index2) => (
							<td key={index2}>{item2}</td>
						)) : null}
					</tr>
				))}
			</Fragment>
	}

	// log("loading=",props.loading,", values=",values,", empty_mess=",props.empty_mess)

	return (
		/* see https://react-bootstrap.netlify.app/components/table/#tables
				don't import bootstrap as a global css because it will kill mine
				instead just import what you need by copying the files & importing them separately

				add "table-sm" for condensed table
		*/
		/*<table className="table table-inverse table-striped table-hover" style={{ textAlign: "left" }}>*/
		<CustomTable striped hover variant="dark">
			<thead>
				<tr>
					{/* <th key="0" scope="col">#</th> */}
					{titles_jsx}
				</tr>
			</thead>
			<tbody>
				{values_jsx}
				{props.loading ?
					<tr><td colSpan={props.titles.length}>
						<SkeletonText width="60%" height="1.2em" />
					</td></tr>
					: null}
				{!props.loading && (!props.values || props.values.length === 0) && props.empty_mess ?
					<tr><td colSpan={props.titles.length}>
						{props.empty_mess}
					</td></tr>
					: null}
			</tbody>
		</CustomTable >
	)
}
